import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from "src/app/shared/services/console.service";
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from "src/app/shared/components/modal-confirm/modal-confirm.component";
import { ListaPrecioDetalleService } from 'src/app/services/lista-precio-detalle.service';

@Component({
  selector: 'app-producto-modal-precio-costo',
  templateUrl: './modal-precio-costo.component.html',
  styleUrls: ['../productos.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ProductoModalPrecioCostoComponent implements OnInit {

  @Output() onPrecioCostoSeleccionado: EventEmitter<any> = new EventEmitter<any>()

  private client: GraphQLClient = null;

  // Modales
  @ViewChild('editarPrecioCosto', { static: true }) editarPrecioCostoModal: ModalDirective;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent

  formPrecioCosto: FormGroup;

  public rut_empresa: number;
  public sucursal_codigo: Number;
  public rut_usuario: Number;
  productoCodigoOriginal: any
  formatoCodigoOriginal: any
  precioCostoOriginal: any

  // Utils
  private log: any

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private formBuilder: FormBuilder,
    private clog: ConsoleService,
    private formValidatorsService: FormValidatorsService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private litaPrecioDetalleService: ListaPrecioDetalleService,
  ) {
    this.client = client;
    this.log = this.clog.log('PRODUCTOS-ADD/EDIT / PRECIO_COSTO')
  }

  ngOnInit() {
    this.rut_empresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursal_codigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = Number(this.accesolocalstorage.getRutUsuario());

    this.createForm()
  }

  createForm() {
    this.formPrecioCosto = this.formBuilder.group({
      precio: ['', [Validators.required, Validators.min(1)]],
    });
  }

  loadAndShow(producto_codigo, formato_codigo, precio_costo) {
     this.productoCodigoOriginal = producto_codigo
     this.formatoCodigoOriginal = formato_codigo
     this.precioCostoOriginal = precio_costo
    this.show()
  }

  clearData() {
    this.formValidatorsService.reset(this.formPrecioCosto)
  }

  show() {
    //this.isEditing = false
    this.clearData()
    this.editarPrecioCostoModal.show()
  }

  hide() {
    this.editarPrecioCostoModal.hide()
  }

  guardarPrecioCosto() {
    this.formValidatorsService.validateAllFormFields(this.formPrecioCosto)
    if (!this.formPrecioCosto.valid)
      return

    const inputParams: any = {
      entidad: {
        empresa_rut: this.rut_empresa,
        sucursal_codigo: this.sucursal_codigo,
        rut_usuario_modificacion:this.rut_usuario,
        precio_costo: this.formPrecioCosto.get('precio').value,
        producto_codigo: this.productoCodigoOriginal,
        formato_codigo: this.formatoCodigoOriginal
      }
    }
    this.modalConfirm.showWithInlineConfig('Editar Precio Costo', '¿Esta Seguro que desea Cambiar el Precio de Costo?', () => {
      //this.listaProductoFormato.splice(index, 1);
      //this.setearFormatoPorDefecto()
      this.litaPrecioDetalleService.guardarPrecioCosto(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
      })
      this.toastrService.success('Operación realizada con éxito')
      this.onPrecioCostoSeleccionado.emit({ ...this.formPrecioCosto.value, produto_codigo: this.productoCodigoOriginal })
      this.editarPrecioCostoModal.hide()
    })
    // if (this.isEditing)
    //   inputParams.entidad.codigo = this.codigoEditado
    //   //this.onAddEdit.emit(respuesta)
    //   this.hide()
    // })
  }
}
